// extracted by mini-css-extract-plugin
export default {"newOptionName":"single-select-field-module__newOptionName--kHsoz"};